<template>
	<div>
		<div class="textCenter" v-if="isLoading">
              <Loading  :isLoading="true" ></Loading>
        </div>
	    <div class="main-container hotel-container" v-else>
            <div class="rule">
            	<ul class="step">
    				<li class="step-arrow "></li>
        			<li class="step-text ">填写订单</li>
        			<li class="step-arrow active"></li>
        			<li class="step-text active">订单支付</li>
        			<li class="step-arrow active"></li>
        			<li class="step-text active ">订单完成</li>
    			</ul>
    			<div class="back-btn-a" @click="returnBack">← 返回</div>
                <div class="main-left fill-order" >
                    <div class="title" id="floatTop">预定信息</div>
                    <div class="content" >
                        <div class="content-item-a">
                            <label class="item-title">入离日期</label>
                            <div class="item-body">
                                <p class="time">{{bookInfo.CheckIn}} 至 {{bookInfo.CheckOut}} <span>{{bookInfo.days}}晚</span></p>
                            </div>
                        </div>
                        <div class="content-item-a">
                            <label class="item-title">房间数量</label>
                            <div class="item-body">
                                <div>
                                    <div class="select-box">
                                        <select v-model="bookInfo.RoomCount" @change="upgrade">
                                            <option :value="index+1" v-for="(rc,index) in RoomCountList">{{index+1}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="content-item-a">
                            <label class="item-title">订房总额</label>
                            <div class="item-body">
                                <span class="price">{{Currency}} {{bookInfo.AdultPrice}}  </span>
                                <span class="day-price" @click="isDailyRatesShow=!isDailyRatesShow" v-show="!isDailyRatesShow">展开每天价格</span>
                                <span class="day-price" @click="isDailyRatesShow=!isDailyRatesShow" v-show="isDailyRatesShow">隐藏每天价格</span>
                            </div>
                        </div>
                        <div class="content-item-a" v-show="isDailyRatesShow">
                            <label class="item-title"></label>
                            <div class="item-body">
                                <div class="date" v-for="rate in bookInfo.DailyRates">
                                    <div class="date-head">{{rate.Date|delUTC|dateShort}}（{{rate.Date|delUTC|dateWeek}}）</div>
                                    <p class="date-price">{{Currency}} {{rate.TotalAmount|numberFloat}}</p>
                                    <p>{{bookInfo.Breakfast}}</p>
                                </div>

                            </div>
                            <div style="padding: 5px 0 0 75px" v-for="item in bookInfo.Surcharges" v-if="bookInfo.Surcharges&&bookInfo.Surcharges.length>0&&!item.IncludeInPrice">
                                <!-- 另包含税/费  -->
                                {{item.Name+'(酒店到付)'}}:
                                <span class="price">{{Currency}} {{item.Price|numberFloat}}</span>
                            </div>
                            <div style="padding: 5px 0 0 75px" v-if="bookInfo.TotalTaxAndFeeAmount">
                                <!-- 另包含税/费  -->
                                TaxAndFee:
                                <span class="price">{{Currency}} {{bookInfo.TotalTaxAndFeeAmount|numberFloat}}</span>
                            </div>
                        </div>


                        <div class="content-item-a" v-show="(bookInfo.details.ID==45023||bookInfo.details.ID==920612||bookInfo.details.ID==402864||bookInfo.details.ID==392288||bookInfo.details.ID==27303||bookInfo.details.ID==79188||bookInfo.details.ID==45093||bookInfo.details.ID==16551||bookInfo.details.ID==1277245)&&bookInfo.RateRource===1">
                            <label class="item-title">加购餐食</label>
                            <div class="item-body">
                                <div class="input-box people" style="height: 30px;width: 70px;line-height: 30px;cursor: default;margin-bottom: 0;" @click="MealsLayer=!MealsLayer">
                                    <i class="iconfont icon-renshu"></i>
                                    添加
                                </div>
                                <span class="price">{{Currency}} {{MealsAmount}}</span>
                            </div>
                        </div>
                        <div class="content-item-a" v-show="MealsAmount!=0">
                            <label class="item-title"></label>
                            <div class="item-body">
                                <div class="more">
                                    <table style="width: 700px;">
                                        <thead>
                                            <tr>
                                                <td>日期</td>
                                                <td>名称</td>
                                                <td>数量</td>
                                                <td>总价</td>
                                                <td>操作</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="S in MealsDataSave" v-if="S.Count">
                                                <td>{{S.DateStr}}</td>
                                                <td>{{S.ProductName}}</td>
                                                <td>{{S.Count}}</td>
                                                <td>{{S.Count*S.BasePrice}}</td>
                                                <td><span class="elemnt" @click="delMeal(S)">-</span></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        
                        <div class="close-layer" v-if="MealsLayer">
                            <div class="layer-content-box">
                                <div class="search-box">
                                    <div class="search">
                                        餐食类型:
                                        <div class="select-box" style="margin-right:20px">
                                            <select v-model="MealType">
                                                <option :value="rc.id" v-for="rc in MealTypeList">{{rc.name}}</option>
                                            </select>
                                        </div>
                                        日期:
                                        <div class="select-box" style="width: 115px;">
                                            <select v-model="handleDate">
                                                <option :value="D" v-for="D in DateList">{{D}}</option>
                                            </select>
                                        </div>
                                        <span>成人: <input type="text" v-model="BAdult"></span>
                                        <span>儿童: <input type="text" v-model="BChildren"></span>
                                    </div>
                                    <div class="search-btn" @click="searchBF()">查询</div>
                                </div>
                                <div class="more" style="height:500px;overflow-y:auto;">
                                    <table>
                                        <thead>
                                            <tr>
                                                <td>名称</td>
                                                <td>日期</td>
                                                <td>使用时间段</td>
                                                <td>餐厅名称</td>
                                                <td>餐厅营业时间</td>
                                                <td>单价</td>
                                                <td>份数</td>
                                                <td>总价</td>
                                                <td>操作</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="M in MealsData">
                                                <td>{{M.ProductName}}</td>
                                                <td>{{M.Date|delUTC|dateToYMDline}}</td>
                                                <td>{{M.EatTimeDetail}}</td>
                                                <td>{{M.RestaurantName}}</td>
                                                <td>{{M.OpenTime}}</td>
                                                <td>{{Currency}}{{M.BasePrice}}</td>
                                                <td>{{M.Count}}</td>
                                                <td>{{M.Count*M.BasePrice}}</td>
                                                <td><span class="elemnt" @click="addMeal(M)">+</span></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="search-foot">
                                    <span class="search-btn" @click="saveMeals">保存</span>
                                    <span class="search-btn" @click="MealsLayer=!MealsLayer" style="background: #ddd;color: #666;">关闭</span>
                                </div>
                            </div>
                        </div>
                        <div class="content-item-a" v-if="bookInfo&&bookInfo.ChimelongList&&bookInfo.ChimelongList.length>0&&bookInfo.RateRource===1">
                            <label class="item-title">马戏场次</label>
                            <div class="item-body">
                                <span>
                                    <div class="select-box" style="width: 210px;">
                                        <select v-model="ChimelongCode" @change="upGradeChi" style="width: 195px;">
                                            <option :value="C" v-for="C in bookInfo.ChimelongList">{{C.Date + " | " +C.SeasonItemText}}</option>
                                        </select>
                                    </div>
                                </span>
                                <span v-if="!ChimelongCode" style="color: #ff3300;">请选择出席场次</span>
                            </div>
                        </div>

                        <div class="content-item-a">
                            <label class="item-title">住客国籍</label>
                            <div class="item-body" style="position: relative;">
                                <div class="time">{{bookInfo.Country.CNName}}</div>
                                
                                <!-- <div class="input-box nation" @click="openCountry()">
                                    <i class="iconfont icon-guoji" style="font-size: 24px"></i>
                                    <span class="country-name">
                                        {{Nationality.CNName}}
                                    </span>
                                </div>
                                <country @select="selectCountry" :isCountryShow="isCountryShow"></country> -->
                            </div>
                            
                        </div>

                        
                        
                        <div class="content-item-a">
                            <label class="item-title">住客姓名</label>
                            <div :class="index>0?'room-mg item-body':'item-body'" v-for="(room,index) in Rooms"> 
                                <div class="item-room-num">房间{{index+1}}</div>
                                <div v-for="(customer,idx) in room">
                                    <div class="input-box">
                                        <input type="text" maxlength="50" :id="`room${index}c${idx}LastName`" @blur="shake(index,idx,'LastName',customer.LastName)" :placeholder="customer.IsChild?'姓(英文或拼音)/儿童':'姓(英文或拼音)'"  v-model="customer.LastName" v-if="bookInfo.From==0||bookInfo.RegionID=='3301'||bookInfo.RegionID=='3201'" oninput="this.value=this.value.replace(/[\u4e00-\u9fa5\d]/g,'');" >
                                        <input type="text" :id="`room${index}c${idx}LastName`" maxlength="50" @blur="shake(index,idx,'LastName',customer.LastName)" placeholder="姓" v-model="customer.LastName" v-else>
                                        <i class="iconfont icon-guanbi user-close-btn" @click="customer.LastName=''" v-if="customer.LastName"></i>
                                    </div>
                                    <div class="input-box">
                                        <input type="text" maxlength="50" :id="`room${index}c${idx}FirstName`" @blur="shake(index,idx,'FirstName',customer.FirstName)" :placeholder="customer.IsChild?'名(英文或拼音)/儿童':'名(英文或拼音)'"  v-model="customer.FirstName" v-if="bookInfo.From==0||bookInfo.RegionID=='3301'||bookInfo.RegionID=='3201'" oninput="this.value=this.value.replace(/[\u4e00-\u9fa5\d]/g,'');">
                                        <input type="text" maxlength="50" :id="`room${index}c${idx}FirstName`" @blur="shake(index,idx,'FirstName',customer.FirstName)" placeholder="名" v-model="customer.FirstName" v-else>
                                        <i class="iconfont icon-guanbi user-close-btn" @click="customer.FirstName=''" v-if="customer.FirstName"></i>
                                    </div>
                                    <div class="input-btn" @click="addCustomer(room)" v-if="idx==0&&bookInfo.From==1" >+</div>
                                    <div class="input-btn" @click="delCustomer(room,idx)" v-if="idx>0&&bookInfo.From==1">-</div>
                                    <br />
                                    <div class="input-box" v-if="bookInfo.NeedIDCard"> 
                                        <input type="text" maxlength="50" :id="`room${index}c${idx}Phone`" @blur="shake(index,idx,'Phone',customer.Phone)" placeholder="手机号码" v-model="customer.Phone" >
                                        <i class="iconfont icon-guanbi user-close-btn" @click="customer.Phone=''" v-if="customer.Phone"></i>
                                    </div>
                                    <div class="input-box id-type-box" v-if="bookInfo.NeedIDCard">
                                        <div class="id-type">
                                            <select v-model="customer.CardType">
                                                <option :value="item.id" v-for="item in papersList" :key="item.id">
                                                    {{item.name}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="input-box" v-if="bookInfo.NeedIDCard">
                                        <input type="text" :id="`room${index}c${idx}CardNumber`" maxlength="50" placeholder="证件号码" v-model="customer.CardNumber" @blur="shake(index,idx,'CardNumber',customer.CardNumber)">
                                        <i class="iconfont icon-guanbi user-close-btn" @click="customer.CardNumber=''" v-if="customer.CardNumber"></i>
                                    </div>
                                 
                                </div>
                                <p class="warning" v-if="index==Rooms.length-1">港澳台及海外酒店住客姓名必须填写有效证件上的英文或拼音</p>
                            </div>
                            
                            <div class="more">
                                <a href="javascript:void(0)">住客对酒店更多要求</a>
                                <div class="ps">如果您对房型有特殊要求，客服需要与酒店联系，确认时间较长，请您耐心等待。</div>
                                <ul>
                                    <li v-for="(sl,idx) in specialList"><label :for="idx+'idx'"><input :id="idx+'idx'" type="checkbox" v-model="sl.isSelect">{{sl.name}}</label></li>
                                
                                </ul>
                                <input type="text" maxlength="40" placeholder="最多20字" v-model="SpecialRequest" />
                                <i class="iconfont icon-guanbi input-close-btn" @click="SpecialRequest=''" v-if="SpecialRequest"></i>
                            </div>
                        </div>

                        <div class="title">酒店提示</div>
                        <div class="content">
                            <p class="info">{{bookInfo.details.GuestGuide}}</p>
                            <label>
                            	<p class="info">
                            		<input type="checkbox" v-model="isAgree"/>
                            		<span>我已阅读并同意，{{bookInfo.CancelPolicy}}</span>(最终解释权归订房易所有)
                            	</p>
                            </label>
                        </div>
                        <div class="btn-group" id="stopScroll">
                            <div class="submit-btn" @click="review">提交订单</div>
                            <div class="re-select-btn"  @click="returnBack">重新选择房型</div>
                        </div>
                    </div>
                </div>
                <div  :class="mapAndHistoryFixed?(isStopMapAndhs?'main-right float-active-stop':'main-right float-active'):'main-right'"  id="mapandhsbox">
                    <div class="right-content">
                        <a class="hotel-name" href="javascript:void(0)">
                        	{{bookInfo.details.HotelName}}
                        	<span class="en-name">({{bookInfo.details.HotelEName||''}}) </span>
                           
                        	<span class="star"></span>
                        </a>
                        <p class="ps">{{bookInfo.details.DistrictName}} | {{bookInfo.details.Address}}</p>
                        <p class="room-name">{{bookInfo.RoomName}}</p>
                        <p class="info"><span>是否含早：</span>{{bookInfo.RPName}}</p>
                        <p class="info" v-show="bookInfo.Bed"><span>床型：</span>{{bookInfo.Bed}}</p>
                        <p class="info" v-show="bookInfo.room.AddBedDesc"><span>加床：</span>{{bookInfo.room.AddBedDesc}}</p>
                        <p class="info" v-show="bookInfo.room.Floor"><span>楼层：</span>{{bookInfo.room.Floor}}层</p>
                        <p class="info" v-show="bookInfo.room.RoomSize"><span>面积：</span>{{bookInfo.room.RoomSize}}平方米</p>
                        <p class="info" v-show="bookInfo.room.NetDesc"><span>宽带：</span>{{bookInfo.room.NetDesc}}</p>
                        <p class="info" v-show="bookInfo.room.WindowText"><span>窗户：</span>{{bookInfo.room.WindowText}}</p>
                        <p class="info" v-show="bookInfo.room.SmokeText"><span>吸烟：</span>{{bookInfo.room.SmokeText}}</p>
                    </div>
                    <div class="total">
                        <p>入住{{bookInfo.days}}晚，{{bookInfo.RoomCount}}间客房</p>
                        <p class="flexBox" v-for="room in bookInfo.DailyRates" v-if="bookInfo.DailyRates&&bookInfo.DailyRates.length>0">
                            <span>{{room.DateStr}}</span>
                            <span>{{'x'+bookInfo.RoomCount}}</span>
                            <span>{{Currency}} {{room.AdultPrice*bookInfo.RoomCount}}</span>
                        </p>
                        <div class="line"></div>
                        <p class="flexBox" v-for="item in bookInfo.Surcharges" v-if="bookInfo.Surcharges&&bookInfo.Surcharges.length>0&&!item.IncludeInPrice">
                            <!-- 另包含税/费  -->
                            {{item.Name+'(酒店到付)'}}
                            <span>{{Currency}}{{item.Price|numberFloat}}</span>
                            
                        </p>
                        <p class="flexBox" v-if="bookInfo.TotalTaxAndFeeAmount">
                            TaxAndFee
                            <span>{{Currency}}{{bookInfo.TotalTaxAndFeeAmount|numberFloat}}</span>
                        </p>
                        <p class="one"><span>总额：</span><span class="price">{{Currency}}<span>{{bookInfo.AdultPrice+ MealsAmount}}</span></span></p>
                    </div>
                </div>
            </div>
        </div>
        <Modal v-show="modal.show" :config="modal" @close="modal.show=false"></Modal>
        <BookReview v-if="bookReview.show" @ok="submit" @cancel="bookReview.show=false" :info="bookReviewInfo" :bookInfo="bookInfo"></BookReview>
	</div>

</template>
<script>
	import Modal from './../../common/cmpnt/Modal/modal.vue'//跳转提示框
    import BookReview from './bookReview/bookReview.vue'//订单预览
    import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲
    import country from './../../common/cmpnt/country/countryC.vue' //选择国籍
	export default{
		name:'book',
		components:{Modal,BookReview,Loading,country},
		data(){
			return{
				bookInfo:this.dao.get('bookInfo'),
				Phone:this.dao.get('userInfo').Phone,
				Currency: this.dao.get('userInfo').Currency,
				isAgree:false,
				isDailyRatesShow:false,
				mapAndHistoryFixed:false,
				isStopMapAndhs:false,
                isLoading:false,
				Rooms:[],
				RoomCountList:[],
				SpecialRequest:'',
                bookReviewInfo:{},
				modal:{
					show:false,
					config:{}
				},
                bookReview:{
                    show:false,
                },
                papersList:[
                    {id:'056001',name:'身份证'},
                    {id:'056003',name:'护照'},
                    {id:'056004',name:'港澳居民来往内地通行证'},
                    {id:'056005',name:'台湾居民来往大陆通行证'},
                    {id:'056007',name:'港澳台居民居住证'},
                    {id:'056010',name:'外国人永久居留证'},
                ],
                CardType:'1',
				specialList:[
			        {'name':'安静房间','index':'-1', 'enValue':'Quiet Room', 'value':'安静房间','isSelect':false},
			        {'name':'无障碍房','index':'0',  'enValue':'Accessible Room', 'value':'无障碍房','isSelect':false},
			        {'name':'立即到店','index':'1',  'enValue':'Arrival Immediate', 'value':'立即到店','isSelect':false},
			        {'name':'无烟房','index':'2',    'enValue':'Non-Smoking Room', 'value':'无烟房','isSelect':false},
			        {'name':'提前到店','index':'3',  'enValue':'Arrival In Advance', 'value':'提前到店','isSelect':false},
			        {'name':'蜜月度假','index':'4',  'enValue':'Honeymoon Holiday', 'value':'蜜月度假','isSelect':false},
			        {'name':'高楼层','index':'5',    'enValue':'High Floor ', 'value':'高楼层','isSelect':false},
			        {'name':'尽量双床','index':'6',  'enValue':'Prefer Twin Beds', 'value':'尽量双床','isSelect':false},
			        {'name':'尽量大床','index':'7',  'enValue':'Prefer Double Bed', 'value':'尽量大床','isSelect':false},
			        // {'name':'免费安排婴儿车','index':'8','enValue':'Free Baby Cot', 'value':'免费安排婴儿车','isSelect':false},
			        {'name':'连通房','index':'9','enValue':'Free Baby Cot', 'value':'连通房','isSelect':false},
			    ],
                lastRoomCount:'',//房间数选择缓存下来
                ChimelongCode:'', //长隆马戏，
                BAdult: 1,//成人早餐数
                BChildren: 0,//儿童早餐数
                MealsData:'',
                MealsDataSave:[],
                MealType:'1',
                MealTypeList:[
                    {id:'1',name:'早餐'},
                    {id:'2',name:'午餐'},
                    {id:'3',name:'晚餐'},
                    {id:'4',name:'早午茶'},
                    {id:'5',name:'下午茶'},
                    {id:'0',name:'其他'}
                ],
                MealsLayer:false,
                MealsAmount:0,
                DateList:[],
                handleDate:'',
                isCountryShow:false,
                Nationality:{
                    "Code2": "CN",
                    "Code3": "CHN",
                    "Num": "156",
                    "Iso": "ISO 3166-2:CN",
                    "ENName": "China",
                    "CNName": "中国大陆"
                },
                
			}
		},

		methods:{
            openCountry(){
                this.isCountryShow =true
            },
            selectCountry(obj){
                this.isCountryShow = false
                console.log(obj)
                if (!obj) return;
                this.Nationality = obj;
                
            },
            shake(r,c,field,val){
                const id = `room${r}c${c}${field}`;
                const inp = document.getElementById(id);
                if(!inp) return;
                const box = inp.parentElement; 
                box.removeAttribute('style')
                if(!val){
                    box.style.border="1px solid #28c667";
                    box.classList.add('blink-border'); 
                    inp.focus();
                    inp.scrollIntoView({block:'center', behavior:'smooth'});
                    setTimeout(() => box.classList.remove('blink-border'), 1200);
                }
            },
            //计算入住日期
            getDatesInRange(startDate, endDate) {
                if(this.bookInfo.RoomName.indexOf('3天')>=0){
                    endDate.setDate(endDate.getDate() + 1);
                }else if(this.bookInfo.RoomName.indexOf('4天')>=0){
                    endDate.setDate(endDate.getDate() + 2);
                }
                let dates = [];
                let currentDate = new Date(startDate);
                while (currentDate <= endDate) {
                    dates.push(this.dateToYMDline(new Date(currentDate)));
                    currentDate.setDate(currentDate.getDate() + 1);
                }
                return dates;
            },
			//添加人数
			addCustomer(room){
				if(room.length>=this.bookInfo.MaxPerson)return;
				room.push({'FirstName':'','LastName':'','Age':'','IsChild':false,'Phone':'','CardType':'1','CardNumber':''});

			},
			//删除人数
			delCustomer(room,idx){
				room.splice(idx,1)
			},
			//初始化最大房间数
			initMaxRoomCount(){
				var Stock=this.bookInfo.Stock;
				//如果是问房，则最大可以选择4间
				if(this.bookInfo.IsAskRoom){
					Stock=8;
				}
				var RoomCountList=[];
				for(var i=0;i<Stock&&i<8;i++){
					RoomCountList.push(i);
				}
				this.RoomCountList=RoomCountList;

                // if(this.bookInfo.ChimelongList&&this.bookInfo.ChimelongList.length>0){
                //     this.RoomCountList=1;
                // }
			},
			//初始化房间入住人数信息
			initialRooms(){
				var RoomCount=this.bookInfo.RoomCount;
				var Stock=this.bookInfo.Stock;
				var AdultCount=this.bookInfo.AdultCount;
				var ChildrenCount=this.bookInfo.ChildrenCount;
				var ChildrenAges=this.bookInfo.ChildrenAges;
				var Rooms=[];
          
                    if(Stock==0){
                        for(var i=0;i<RoomCount&&i<8;i++){
                            if(i>=8)break;//最多只能有8间
                            Rooms[i]=[];
                            if(this.bookInfo.From==0){
                                for(var j=0;j<AdultCount;j++){
                                    Rooms[i].push({'FirstName':'','LastName':'','Age':'','IsChild':false,'Phone':'','CardType':'1','CardNumber':''});
                                }
                                if(ChildrenCount>0){
                                    for(var j=0;j<ChildrenCount;j++){
                                        Rooms[i].push({'FirstName':'','LastName':'','Age':ChildrenAges[j],'IsChild':true,'Phone':'','CardType':'1','CardNumber':''});
                                    } 
                                }
                             
                            }else{
                                Rooms[i].push({'FirstName':'','LastName':'','Age':'','IsChild':false,'Phone':'','CardType':'1','CardNumber':''});

                            }
                        }

                    }else{
                        for(var i=0;i<RoomCount&&i<Stock;i++){
                            if(i>=8)break;//最多只能有8间
                            Rooms[i]=[];
                            if(this.bookInfo.From==0){
                                for(var j=0;j<AdultCount;j++){
                                    Rooms[i].push({'FirstName':'','LastName':'','Age':'','IsChild':false,'Phone':'','CardType':'1','CardNumber':''});
                                }
                                if(ChildrenCount>0){
                                    for(var j=0;j<ChildrenCount;j++){
                                        Rooms[i].push({'FirstName':'','LastName':'','Age':ChildrenAges[j],'IsChild':true,'Phone':'','CardType':'1','CardNumber':''});
                                    } 
                                }
                               
                            }else{
                                Rooms[i].push({'FirstName':'','LastName':'','Age':'','IsChild':false,'Phone':'','CardType':'1','CardNumber':''});

                            }
                        }
                    }

				this.Rooms=Rooms;
            },
			isFrCustomerInfoCorrect(list){
 				for(var i=0,length=list.length;i<length;i++){
 		 			for(var j=0;j<list[i].length;j++){

 		 				if(!list[i][j].FirstName||!list[i][j].LastName){
							return false;
						}
 		 			}
 		 		}
 		 		return true;
 		 	},
			isCustomerInfoCorrect(list){
 		 		for(var i=0,length=list.length;i<length;i++){
 		 			for(var j=0;j<list[i].length;j++){
                        if(!list[i][j].FirstName||!list[i][j].LastName){
                            this.error({title:'提示',content:'请输入住客姓名！'});
                            return ;
                            
                        }
                        if(this.bookInfo.NeedIDCard){
                            if(!this.checkMobile(list[i][j].Phone)||!this.paperType(list[i][j].CardType,list[i][j].CardNumber)){
                                return;
                            }
                            // this.checkMobile(list[i][j].Phone);
                            // this.paperType(list[i][j].CardType,list[i][j].CardNumber)
                            // if(!list[i][j].CardNumber){
                            //     this.error({title:'提示',content:'请输入住客证件号码！'});
                            //     return;
                            // }
                           
                        }
 		 			}
 		 		}
 		 		return true;
 		 	},
 		 	//返回详情页
			returnBack(){
				this.$router.push('/hotelDetails');
			},
 		 	//组合要求
 		 	specialListInitial(list){
 		 		var str=''
 		 		for(var i=0;i<list.length;i++){
					if(list[i].isSelect){
						if(this.bookInfo.From==1){
							str+=list[i].name+' ';
						}else{
							str+=list[i].enValue+' ';
						}
					}
 		 		}
 		 		str+=this.remarks||'';
 		 		return str;
 		 	},
 		 	//组合入住人
 		 	roomsInitial(list){
                var that=this;
 		 		var arr=[];
 		 		for(var i=0;i<list.length;i++){
 		 			for(var j=0;j<list[i].length;j++){
                    
                
 		 				arr.push(list[i][j]);
 		 			}
 		 		}
 		 		return arr;
 		 	},
            // 组合餐食
            MealsInitial(list){
                var that=this;
 		 		var arr=[];
 		 		for(var i=0;i<list.length;i++){
 		 			var obj={
                        'Count':list[i].Count,
                        'Token':list[i].Token
                    };
                    arr.push(obj)
 		 		}
                return arr
            },
            upGradeChi(){
                this.bookInfo.Token = this.ChimelongCode.Token
                this.bookInfo.AdultPrice = this.ChimelongCode.SettlePrice
                this.dao.set('bookInfo',this.bookInfo);
            },

 		    //重置房间数 加载房型
            upgrade(){
                var that=this;
               
                var params={
                    Token:that.bookInfo.Token,
                    RoomCount:that.bookInfo.RoomCount,
                }
                //检查是否可以预订
				that.modal={
					show:true,
					content:'正在为您核对酒店库存信息，请稍后....',
				}
                that.postRequest({
                    url: that.Api.upgrade,
                    params: params
                }).then(res => {
                	that.modal.show=false;
                    if (res&&res.IsSuccess) {
                        that.bookInfo.AdultPrice=res.Result.Amount;
                        that.bookInfo.DailyRates=res.Result.DailyRates;
                        that.bookInfo.Token=res.Result.Token;
                        // 更新订单缓存信息
                        that.dao.set('bookInfo',that.bookInfo);
                        var flag = that.bookInfo.details.ID=='45023'?true:that.bookInfo.details.ID=='920612'?true:that.bookInfo.details.ID=='402864'?true:that.bookInfo.details.ID=='392288'?true:that.bookInfo.details.ID=='27303'?true:that.bookInfo.details.ID=='79188'?true:that.bookInfo.details.ID=='45093'?true:that.bookInfo.details.ID=='16551'?true:that.bookInfo.details.ID=='1277245'?true:false
                        if(flag&&that.bookInfo.RateRource===1){
                            that.upgradeChilong(res.Result.Token)
                        }

                        that.lastRoomCount=this.bookInfo.RoomCount;
                        that.initialRooms();
                    }else{
                      
                        that.error({title:'提示',content:res.Msg||'没有获取到价格, 请重试!'}); 
                        that.bookInfo.RoomCount=that.lastRoomCount;
                       
                 

                    }
                });
            },
            upgradeChilong(token){
                var that = this
                var param={
                        DateStart:that.bookInfo.CheckIn,
                        DateEnd:that.bookInfo.CheckOut,
                        SRoomId:that.bookInfo.SupRoomId,
                        Token:token
                }  
                //检查是否可以预订
				that.modal={
					show:true,
					content:'正在为您添加马戏场次信息，请稍后...',
				}
                that.postRequest({
                    url:that.Api.getChimelong, 
                    params:param
                }).then(Result => {
                    that.modal.show=false;
                    if(Result&&Result.IsSuccess){
                        that.bookInfo.Chimelong = Result.Result
                        var arr = []
                        ///长隆
                        for(let j = 0;j < Result.Result[0].SeasonInfos.length;j++){
                            Result.Result[0].SeasonInfos[j].Date = Result.Result[0].Date
                        }
                        arr = arr.concat(Result.Result[0].SeasonInfos)
                        that.bookInfo.ChimelongList = arr
                        that.dao.set('bookInfo',that.bookInfo);
                        for(let i = 0; i<that.bookInfo.ChimelongList.length; i++){
                            if(that.bookInfo.ChimelongList[i].IsLastSeason){
                                that.ChimelongCode = that.bookInfo.ChimelongList[i]
                                that.bookInfo.Token = that.ChimelongCode.Token
                                that.bookInfo.AdultPrice = that.ChimelongCode.SettlePrice
                                that.dao.set('bookInfo',that.bookInfo);
                                break;
                            }
                        }
                    }   
                });

            },
            review(){
                var that=this;
                const rooms=this.Rooms;
                //判断用户信息是否输入完整
                for(let r=0;r<rooms.length;r++){
                    for(let c=0;c<rooms[r].length;c++){
                        const g=rooms[r][c];
                        if(!g.LastName||!g.LastName.trim()){
                            this.shake(r,c,'LastName'); return;
                        }
                        if(!g.FirstName||!g.FirstName.trim()){
                            this.shake(r,c,'FirstName'); return;
                        }
                        if(this.bookInfo.NeedIDCard){
                            if(!g.Phone||!g.Phone.trim()){
                                this.shake(r,c,'Phone'); return;
                            }
                            if(!g.CardNumber||!g.CardNumber.trim()){
                                this.shake(r,c,'CardNumber'); return;
                            }
                        }
                    }
                }
                
                if(that.bookInfo.From==0){
                    if(!that.isFrCustomerInfoCorrect(that.Rooms)){
                        that.error({title:'提示',content:'请正确住客顾客信息！'});
                        return;
                    }
                }else{
                    if(!that.isCustomerInfoCorrect(that.Rooms)){
                        that.error({title:'提示',content:'请正确住客顾客信息！'});
                        return;
                    }
                }
                if(!that.isAgree){
                    this.error({title:'提示',content:'请先同意预订规则！'});
                    return;
                }
                var SpecialRequest = that.specialListInitial(that.specialList)+' '+that.SpecialRequest;
                var Guests = that.roomsInitial(that.Rooms);
                var ChimelongCode = that.ChimelongCode
                this.bookReviewInfo = {SpecialRequest,Guests,ChimelongCode}
                this.bookReview.show=true;


            },
			//提交
			submit(){
 		 		var that=this;
 		 		//检查是否可以预订
 		 		that.modal={
					show:true,
					content:'正在为您核对酒店库存信息，请稍后....',
				}
				that.checkBookAble(that.bookInfo.Token,function(){
					that.modal.show=false;
					// that.book();
					that.checkAccount();
				})
 		 	},

 		    //查询解析
            // getRestoreToken(){
            //     var that=this;
            //     that.isLoading=true;
            //     var params={
            //         Token:that.bookInfo.Token,
            //     }
            //     that.postRequest({
            //         url: that.Api.getRestoreToken,
            //         params: params
            //     }).then(res => {
            //         that.isLoading=false;
            //         if (res&&res.IsSuccess) {
            //             that.bookInfo.Amount=res.Result.Amount;
            //             that.bookInfo.CheckIn=res.Result.CheckIn;
            //             that.bookInfo.CheckOut=res.Result.CheckOut;
            //             that.bookInfo.details.HotelName=res.Result.HotelName;
            //             that.bookInfo.RPName=res.Result.RPName;
            //             that.bookInfo.RoomCount=res.Result.RoomCount;
            //             that.bookInfo.RoomName=res.Result.RoomName;
            //             that.$nextTick(() => {
            //                 if(localStorage.getItem('lang')=='t'){
            //                     that.$zh_tran(localStorage.getItem('lang'))
            //                 }    
            //             })
            //         } else {
            //             that.error({title:'提示',content:'请重新刷新页面'});
            //         }
            //     });
            // },
            //搜索早餐
            searchBF(){
                var that=this;
                if(that.BAdult<1&&that.BChildren<1){
                    this.error({title:'提示',content: '您尚未添加用餐人数'});
                    return
                }
                var params={
                    CnHotelId:that.bookInfo.details.ID,
                    MealType:that.MealType,
                    Date:that.handleDate,
                    ADTMealNum:that.BAdult,
                    CHDMealNum:that.BChildren
                }
                that.modal={
                    show:true,
                    content:'正在查询，请稍后..',
                }
                that.postRequest({
                    url: that.Api.getChimelongMeals,
                    params: params
                }).then(res => {
                    that.modal.show=false;
                    if (res&&res.IsSuccess) {
                        if(res.Result){
                            res.Result.forEach( i => {
                                i.Count = 0
                            })
                        }
                        that.MealsData = res.Result
                    } else {
                        this.error({title:'提示',content: '该时段暂无提供餐食。'});
                    }
                });
            },
            saveMeals(){
                var that = this
                var dataC = that.MealsDataSave
                var flag = false
                var arry = []
                if(that.MealsData.length>0){
                    that.MealsData.forEach(item =>{
                        item.flag = true
                        if(item.Count>0){
                            flag = true
                            if(that.MealsDataSave.length>0){
                                that.MealsDataSave.forEach(i => {
                                    if(i.ProductCode==item.ProductCode&&i.Date==item.Date){
                                        i.Count = item.Count
                                        item.flag = false
                                    }
                                })
                                if(item.flag){
                                    arry.unshift(JSON.parse(JSON.stringify(item)))
                                }
                            }else{
                                arry.unshift(JSON.parse(JSON.stringify(item)))
                            }
                        }
                    })
                    that.MealsDataSave = that.MealsDataSave.concat(arry)
                }
                that.calculation()
                if(flag){
                    this.error({title:'提示',content: '餐食添加成功'});
                }else{
                    this.error({title:'提示',content: '您此次尚未添加餐食'});
                }
                this.MealsLayer = false
            },
            addMeal(item){
                this.MealsData.forEach(i =>{
                    if(i.ProductCode==item.ProductCode&&i.Date==item.Date){
                        i.Count++
                    }
                })
            },
            delMeal(item){
                var ix = 0
                this.MealsDataSave.forEach((i,index) =>{
                    if(i.ProductCode==item.ProductCode&&i.Date==item.Date){
                        --i.Count
                        if(i.Count==0){
                            ix = index+1
                        }
                    }
                })
                if(ix>=1){
                    this.MealsDataSave.splice(ix-1,1)
                }
                this.calculation()

            },
            calculation(){
                var that=this
                var amount = 0
                var price = 0
                if(that.MealsDataSave.length>0){
                    that.MealsDataSave.forEach(i=>{
                        if(i.Count>0){
                            price = i.Count*i.BasePrice
                            amount = amount+price
                        }
                    })
                }
                that.MealsAmount = amount
                that.bookInfo.MealsAmount = amount
            },
            //查询是否有额度，有的话直接下单，
            checkAccount(){
                var that=this;
                var params={
                    Token:that.bookInfo.Token,
                }
                that.modal={
                    show:true,
                    content:'正在为您检查结算方式和信贷额度，请稍后..',
                }
                that.postRequest({
                    url: that.Api.checkAccount,
                    params: params
                }).then(res => {
                    that.modal.show=false;
                    if (res&&res.IsSuccess) {
                       that.book(true)
                    } else {
                       that.book(false)
                    }
                });
            },

            
 		 	book(UseCreditAccount){
 		 		var that=this;
	 		 	var SpecialRequest=that.specialListInitial(that.specialList);
	 		 	var Guests=that.roomsInitial(that.Rooms);
                var Options=that.MealsInitial(that.MealsDataSave)
	 		 	var param={
					SpecialRequest:SpecialRequest+that.SpecialRequest,
					Guests:Guests,
					Token:that.bookInfo.Token,
					UseCreditAccount:UseCreditAccount,
                    Options:Options,
                    SeasonCode:that.ChimelongCode?that.ChimelongCode.SeasonCode+'|'+that.ChimelongCode.SeasonItemText:''
				}
         		that.modal={
					show:true,
					content:'正在为您提交订单，请稍后...',
				}
 		 		that.postRequest({
						url:that.Api.createBook, 
						params:param
					}).then(res => {
						that.modal.show=false;
						that.isSubmit=false;
					    if(res&&res.IsSuccess){
                            // that.dao.set('bookInfo','');//将当前缓存的订单信息清除，防止再次回来的情况
					    	if(UseCreditAccount){
					    		that.$router.push('/bookComplete?OrderNO='+res.Result.MainOrderID);
					    	}else{
                                var time = Date.parse(new Date())
					    		that.$router.push('/bookComfirm?OrderNO='+res.Result.MainOrderID+'&time='+time);
					    	}
					    }else if(!res.IsSuccess){
                            this.error({title:'提示',content: res.Msg});
					    }
				});
 		 	},
			// 检查是否可以预订
			checkBookAble(token,callback){
				var that=this;
				that.isSubmit=true;
				var param={
                    token:token,
				}
				that.postRequest({
						url:that.Api.checkBookable, 
						params:param
					}).then(res => {
						that.isSubmit=false;
						//当IsSuccess==true时，表示有库存可以预订
					    if(res){
					    	if(res.IsSuccess){
								callback();
					    	}else{
                                 that.modal.show=false;
 								this.error({title:'提示',content:res.Msg||'不能预订'});
					    	}
					    }
				});	
			},
			//处理屏幕滚动事件
            handleScroll(e){
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                var floatTop = document.querySelector('#floatTop')?document.querySelector('#floatTop').offsetTop:0;
                var stopScrollTop =document.querySelector('#stopScroll')? document.querySelector('#stopScroll').offsetTop:0;
                var mapandhsbox =document.querySelector('#mapandhsbox');
                this.mapAndHistoryFixed=scrollTop >( floatTop+55);
                if (scrollTop > floatTop) {
                    if(scrollTop>stopScrollTop-200){
                        mapandhsbox.style.top=(stopScrollTop-300)+'px';
                        this.isStopMapAndhs=true;
                    }else{
                        mapandhsbox.style.top='0px';
                        this.isStopMapAndhs=false;
                    }
                } 
            }

		},
		mounted(){
            //如果没有订单信息，则返回首页
            if(!this.bookInfo)this.$router.push('/');
			document.title='订单填写---订房易';
            // this.getRestoreToken();
			//初始化房间入住人数信息
			this.initialRooms();
			//初始化最大房间数
			this.initMaxRoomCount();
            this.DateList = this.getDatesInRange(new Date(this.bookInfo.CheckIn),new Date(this.bookInfo.CheckOut))
            this.handleDate = this.DateList[1]
			//滚动监听开始
            window.addEventListener('scroll', this.handleScroll);
            var obj=this.dao.get('hotelDetailsParams');
            obj.CheckIn=this.bookInfo.CheckIn;
            obj.CheckOut=this.bookInfo.CheckOut;
            this.dao.set('hotelDetailsParams',obj);
            this.lastRoomCount=this.bookInfo.RoomCount;
            var that = this
            for(let i = 0; i<that.bookInfo.ChimelongList.length; i++){
                if(that.bookInfo.ChimelongList[i].IsLastSeason){
                    that.ChimelongCode = that.bookInfo.ChimelongList[i]
                    that.bookInfo.Token = that.ChimelongCode.Token
                    that.bookInfo.AdultPrice = that.ChimelongCode.SettlePrice
                    that.dao.set('bookInfo',that.bookInfo);
                    break;
                }
            }
		},
		destroyed () {
            window.removeEventListener('scroll', this.handleScroll);
        }
	}
</script>
<style scoped>
.nation {
    cursor: pointer;
    display: flex !important;
    align-items: center;
    gap: 8px;

}
.nation .country-name {
    width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/book.vue